import { useSearchParams } from 'react-router-dom';

import {
  IGNORE_AS_FILTERS,
  PAGE_QUERY_PARAM,
  PAGE_SIZE_QUERY_PARAM,
  SORT_BY_QUERY_PARAM_NAME,
} from '@/shared/components/ui/data-table/hooks/use-filter-params/use-filter-params.constants';
import { TUsePagination } from '@/shared/components/ui/pagination/hooks/use-pagination-query-params/use-pagination-query-params.types';

export const DEFAULT_PAGE = '1';
export const DEFAULT_PAGE_SIZE = '25';

export const usePaginationQueryParams = (
  isPaginated?: boolean,
): TUsePagination => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page =
    Number(searchParams.get(PAGE_QUERY_PARAM)) || Number(DEFAULT_PAGE);
  const pageSize =
    Number(searchParams.get(PAGE_SIZE_QUERY_PARAM)) ||
    Number(DEFAULT_PAGE_SIZE);
  const sortBy = searchParams.get(SORT_BY_QUERY_PARAM_NAME) || '';

  const getFiltersCount = (): number => {
    const appliedFilters = Array.from(searchParams.entries()).filter(
      ([key]) => !IGNORE_AS_FILTERS.includes(key),
    );

    return appliedFilters.length;
  };

  const resetFilters = (defaults?: Record<string, string>) => {
    const newParams = new URLSearchParams(defaults);

    if (isPaginated) {
      newParams.set('page', DEFAULT_PAGE);
      newParams.set('pageSize', String(pageSize));
    }

    if (sortBy) {
      newParams.set(SORT_BY_QUERY_PARAM_NAME, sortBy);
    }

    setSearchParams(newParams);
  };

  return {
    page,
    pageSize,
    resetFilters,
    getFiltersCount,
  };
};
